import React from 'react';
import classnames from 'classnames';
import Chip from '@ifit/mp-chip';
import Icon from '@ifit/react-icons/dist/components/icon';
import LOCKED_SOLID from '@ifit/react-icons/dist/icons/LOCKED_SOLID';
import { white } from '@ifit/base-coat/js/colors';
import { withTheme } from '@ifit/themes/withTheme';
import './index.scss';

export interface IProps {
  imageUrl: string;
  onClick: React.MouseEventHandler<HTMLAnchorElement>;
  tagPrimary: string;
  title: string;
  className?: string;
  completed?: string;
  live?: boolean;
  locked?: boolean;
  tagSecondary?: string;
  themeClass?: string;
}

const CardFeed = ({
  className,
  completed,
  imageUrl,
  live,
  locked,
  onClick,
  tagPrimary,
  tagSecondary,
  themeClass,
  title,
  ...rest
}: IProps) => {
  return (
    <a
      href="#"
      onClick={onClick}
      className={classnames(
        'mp-card-feed',
        { completed: Boolean(completed) },
        { locked: Boolean(locked) },
        themeClass,
        className
      )}
      data-testid="mp-card-feed"
      {...rest}
    >
      <article className="mp-card-feed-article">
        <div className="mp-card-feed-image-container">
          <img src={imageUrl} alt="" className="mp-card-feed-image" />
        </div>

        <div className="mp-card-feed-details-container">
          <header className="mp-card-feed-header">
            <h2 className="mp-card-feed-title">{title}</h2>
          </header>

          <div className="mp-card-feed-tags">
            <div
              className="mp-card-feed-tag-primary"
              data-testid="mp-card-feed-tag-primary"
            >
              {completed ? (
                <span data-testid="mp-card-feed-completed"><Chip>{completed}</Chip></span>
              ) : (
                tagPrimary && <Chip live={live}>{tagPrimary}</Chip>
              )}
            </div>

            {tagSecondary && !locked && !completed && (
              <div
                className="mp-card-feed-tag-secondary"
                data-testid="mp-card-feed-tag-secondary"
              >
                <Chip>{tagSecondary}</Chip>
              </div>
            )}

            {locked && (
              <div className="locked-chip" data-testid="mp-card-feed-locked-icon">
                <Chip>
                  <Icon
                    icon={LOCKED_SOLID}
                    color={white}
                    size={18}
                    className="mp-card-up-next-locked-icon"
                    data-testid="mp-card-up-next-locked-icon"
                  />
                </Chip>
              </div>
            )}
          </div>
        </div>
      </article>
    </a>
  );
};

export default withTheme(CardFeed);
